// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"971cafbe","340":"6d942924","483":"c16a7093","709":"f8b6ae21"}[chunkId] + ".chunk.js";
};